import styled from 'styled-components';
import Toolbar from '@material-ui/core/Toolbar';
import AppBar from '@material-ui/core/AppBar';

// UTILITY
import { breakpoints as bp } from '@/utility/breakpoints';

export const StyledToolbar = styled(Toolbar)`
  height: 80px;
  background-color: ${p => p.theme.palette.subheader.background};
  color: ${p => p.theme.palette.subheader.color};

  ${bp.down('sm')} {
    height: auto;
    min-height: 60px;
  }

  @media (min-width: 600px) {
    &.MuiToolbar-gutters {
      padding-left: 30px;
      padding-right: 30px;
    }
  }

  .toolbar {
    &__link {
      display: block;
    }
  }

  .profile-button {
    margin-left: auto;
  }
`;
export const StyledAppBar = styled(AppBar)`
  ${bp.down('xs')} {
    position: fixed;
    top: 0;

    &.results,
    &.superbundle-results,
    &.channels {
      position: static;
    }
  }
  &.superbundle-results,
  &.results {
    .right-section {
      display: none;
    }
  }

  ${bp.down('sm')} {
    &.fmb,
    &.superbundle-results,
    &.channels {
      ${StyledToolbar} {
        max-height: 64px;
      }
    }
  }
`;

export default StyledToolbar;
